import { autoinject, BindingEngine } from 'aurelia-framework';
import { Location } from "../../models/location";
import { Api } from "../../services/api";
import { applicationLogger } from "../../logging/logger";
import { NotificationRecipient } from "../../models/notification-recipient";

@autoinject
export class NotificationRecipientsList {
	location: Location;
	api: Api;
	active: boolean;
	bindingEngine: BindingEngine;
	subscription: any;
	recipients: Array<NotificationRecipient>;

	constructor(api: Api, bindingEngine: BindingEngine) {
		this.api = api;
		this.bindingEngine = bindingEngine;
	}

	bind(bindingContext: any, overrideContext: any) {
		this.location = bindingContext.location;
	}

	async attached() {
		this.active = true;
		this.recipients = await this.getRecipients();
		this.active = false;
	}

	async getRecipients() {
		this.active = true;
		const recipients = await this.api.getNotificationRecipients(this.location.id);
		this.active = false;
		return recipients;
	}
}


